import { ArrowDownOnSquareIcon } from "@/icons/outline";
import { addYears, format, subYears } from "date-fns";
import React, { useState } from "react";
import ReactDatePicker from "react-datepicker";
import { connect } from 'react-redux';
import { DateInputFormat } from "../../common/DateComponents.js";
import Spinner from "../../common/Spinner.js";
import { Actions as BAMBOO_ACTIONS } from './store/bambooActions.js'

const BambooImport = ({
    importTimesheets,
    importLeave,
    importingTimesheets,
    importingLeave,
    isFor,
}) => {
    const [startDate, setStartDate] = useState(() => {
        const today = new Date();
        const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
        return new Date(firstDayOfMonth.getTime() - (firstDayOfMonth.getTimezoneOffset() * 60000));
    });
    const [endDate, setEndDate] = useState(() => {
        const today = new Date();
        const lastDayOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);
        return new Date(lastDayOfMonth.getTime() - (lastDayOfMonth.getTimezoneOffset() * 60000));
    });

    if (!isFor || isFor == 'Timesheets') return null

    return (
        <div>
            <div className="row">
                <h5>Import {isFor} from Bamboo HR</h5>
                <div className="col-xs-7 pl-0">

                    <div className="col-xs-6 pl-0">
                        <label>From</label>
                        <ReactDatePicker
                            selected={startDate}
                            onChange={(date) => {
                                if (date) setStartDate(date)
                            }}
                            minDate={subYears(new Date(), 10)}
                            maxDate={addYears(new Date(), 10)}
                            dateFormat="dd/MM/yyyy"
                            customInput={<DateInputFormat />}
                        />
                        {/*<input id="date" type="text" className="form-control remove_error" name="date" />*/}
                        <div className="clearfix" />
                    </div>
                    <div className="col-xs-6 pl-0">
                        <label htmlFor=" ">To</label>
                        <ReactDatePicker
                            selected={endDate}
                            onChange={(date) => {
                                if (date) setEndDate(date)
                                if (startDate > date) setStartDate(date)
                            }}
                            minDate={subYears(new Date(), 10)}
                            maxDate={addYears(new Date(), 10)}
                            dateFormat="dd/MM/yyyy"
                            customInput={<DateInputFormat />}
                        />
                        <div className="clearfix" />
                    </div>

                    <div className="clearfix" />

                </div>

                <div className="col-xs-5 pr-0" style={{ marginTop: 23 }}>
                    {(isFor === 'Timesheets' && importingTimesheets) || (isFor === 'Leave' && importingLeave) ?
                        <button className="btn btn-default pull-right">
                            <Spinner style={{ height: "1.5em", float: "left" }} className="animate-spin" />
                            <div style={{ float: "left", marginLeft: 5, marginRight: 5 }}>Importing</div>
                        </button>
                        :
                        <button
                            className='btn btn-default pull-right'
                            onClick={() => {
                                switch (isFor) {
                                    case 'Leave':
                                        importLeave(format(startDate, 'yyyy-MM-dd'), format(endDate, 'yyyy-MM-dd'))
                                        break
                                    // case 'Timesheets':
                                    //     importTimesheets(startDate, endDate)
                                    //     break
                                }
                            }}>
                            <ArrowDownOnSquareIcon style={{ height: "1.5em", float: "left" }} />
                            <div style={{ float: "left", marginLeft: 5, marginRight: 5 }}>Import from Bamboo HR</div>
                        </button>
                    }
                </div>
            </div>

        </div>
    )
}


const mapStateToProps = (state, ownProps) => {
    return {
        importingTimesheets: state.integration?.hris?.bambooHr?.importingTimesheets,
        importingLeave: state.integration?.hris?.bambooHr?.importingLeave
    }
}

const mapDispatchToProps = dispatch => ({
    importTimesheets: (from, to) => dispatch(BAMBOO_ACTIONS.importTimesheets(from, to)),
    importLeave: (from, to) => dispatch(BAMBOO_ACTIONS.importLeave(from, to)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(BambooImport) 